import { ActivityItem, DefaultButton, IActivityItemProps, Icon, IPanelStyles, Link, mergeStyleSets, Panel, PanelType } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import fascicoliService from '../../services/fascicoli.service';
import { Log_Operation } from '../../shared/enums';

import { IFascicolo } from '../../shared/interfaces';
import Utilities from '../../shared/Utilities/utilities';
import { RootState } from '../../store';
import { toastRef } from '../Layout/Layout';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';

const classNames = mergeStyleSets({
    exampleRoot: {
        paddingBottom: '20px',
    },
    nameText: {
        fontWeight: 'bold',
    },
});

export interface StoriaFascicoloProps {
    loading?: boolean
    extraCssClass?: string
    selectedFascicoloNode?: IFascicolo
    panelHeaderText: string
    panelIsOpen: boolean
    onDismiss: () => void

}

type Props = StoriaFascicoloProps;

const StoriaFascicolo: React.FunctionComponent<Props> = (props) => {

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [loading, setLoading] = useState(false);
    const [activityItems, setActivityItems] = useState<any[]>([])

    useEffect(() => {
        setPanelIsOpen(props.panelIsOpen);
    }, [props.panelIsOpen]);

    useEffect(() => {
        if (props.selectedFascicoloNode && currentAoo && panelIsOpen) {
            setLoading(true);
            fascicoliService.getStoria(currentAoo.id, currentUor?.id!, props.selectedFascicoloNode.id)
                .then(logs => {
                    let activities: any[] = [];
                    logs.forEach(el => {
                        let message = el.message;
                        let userName = el.username?.split('<')[0];
                        let uor = el.uor;
                        let linkText = userName;
                        if (uor) {
                            linkText += " | " + uor;
                        }
                        let item: IActivityItemProps = {
                            activityDescription: [
                                <Link key={2} className={classNames.nameText}>{linkText}</Link>,
                                <div key={1}>{message}</div>,

                            ],
                            activityIcon: getActivityIcon(el.operation!),
                            timeStamp: getActivityTimeStamp(el.date!),

                        };
                        activities.push({ key: el.id, ...item });
                    });
                    setActivityItems(activities);
                    setLoading(false);
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: 'Non è stato possibile recuperare la storia del fascicolo',
                            life: 5000
                        });
                    }
                    setLoading(false);
                })
        }
    }, [props.selectedFascicoloNode, currentAoo, currentUor, panelIsOpen]);

    //metodo per il bottone di chiusura del panel
    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Chiudi"
                />
            </React.Fragment>
        );
    }

    //metodo per il render delle icone
    const getActivityIcon = (operation: Log_Operation) => {
        switch (operation) {
            case Log_Operation.register_protocol:
                return (
                    <FontAwesomeIcon icon={['fal', 'file-certificate']} />

                );
            case Log_Operation.create_fascicolo:
            
                return (
                    <Icon iconName={'Add'} />

                );
            case Log_Operation.update_fascicolo:
           
                return (
                    <Icon iconName={'PageEdit'} />

                );
            case Log_Operation.close_fascicolo:
                return (
                    <Icon iconName={'Lock'} />


                );
            case Log_Operation.open_fascicolo:
                return (
                    <Icon iconName={'Unlock'} />
                );

            case Log_Operation.get_fascicolo:
            case Log_Operation.get_fascicoli:
            case Log_Operation.get_protocolli_fascicolo:
           
                return (
                    <Icon iconName={'View'} />
                );
            case Log_Operation.delete_fascicolo:
            
                return (
                    <Icon iconName={'Trash'} />
                );
            

            default:
                return (
                    <Icon iconName={'Document'} />
                );


        }
    };


    //metodo per il render della data + ora
    const getActivityTimeStamp = (date: Date) => {
        return Utilities.FormatDate(date, false);
    };


    return (
        <div className={`${props.extraCssClass}`}>
            <Panel
                key='fascicoloStoria'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                isFooterAtBottom={false}
            >
                <CircleLoader loaderClass='loader-large' loading={loading} />
                <div className={`position-relative my-scroll-div`}>
                    <div className={`my-component-content`}>

                        {activityItems.map((item) => (
                            <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
                        ))}

                    </div>

                </div>
            </Panel>
        </div>

    )
}

export default StoriaFascicolo; 